import type { AccountType } from '@/api';

export const ACCOUNT_TYPE: Record<AccountType, AccountType> = {
	USER: 'USER',
	GUEST: 'GUEST',
};

export const DEFAULT_PAGE_SIZE = 20;

export const QUERY_KEYS = {
	FOR_YOU_FOLLOW_UP: 'for-you-follow-up-conversations',
	FOR_YOU_TRENDING: 'for-you-trending-conversations',
	CONVERSATIONS: 'conversations',
	CONVERSATION_DETAILS: 'conversation-details',
	CONVERSATION_COMMENTS: 'conversation-comments',
	CONVERSATION_FOLLOW_UP: 'conversation-follow-up',
	CONVERSATION_MESSAGES: 'conversation-messages',
	TRENDING_CONVERSATIONS: 'trending-conversations',
	RISING_CONVERSATIONS: 'rising-conversations',
	NEW_CONVERSATIONS: 'new-conversations',
	MOST_VIEWED_CONVERSATIONS: 'most-viewed-conversations',
	CONVERSATION_MESSAGE_TAGS: 'conversation-message-tags',
	CONVERSATION_MESSAGE_CONTENT: 'conversation-message-content',
	CONVERSATION_COMMENT_REPLIES: 'comment-replies',
} as const;
